import React from 'react';
import './StarRating.css';

interface StarRatingProps {
    rating: number;
    onChange?: (rating: number) => void;
    readOnly?: boolean;
    size?: 'small' | 'medium' | 'large';
}

const StarRating: React.FC<StarRatingProps> = ({
    rating,
    onChange,
    readOnly = false,
    size = 'medium'
}) => {
    const [hoverRating, setHoverRating] = React.useState(0);

    const handleClick = (value: number) => {
        if (!readOnly && onChange) {
            onChange(value);
        }
    };

    const handleMouseEnter = (value: number) => {
        if (!readOnly) {
            setHoverRating(value);
        }
    };

    const handleMouseLeave = () => {
        if (!readOnly) {
            setHoverRating(0);
        }
    };

    const displayRating = hoverRating || rating;

    return (
        <div className={`star-rating star-rating-${size} ${readOnly ? 'read-only' : 'interactive'}`}>
            {[1, 2, 3, 4, 5].map((value) => (
                <button
                    key={value}
                    type="button"
                    className={`star ${value <= displayRating ? 'filled' : 'empty'}`}
                    onClick={() => handleClick(value)}
                    onMouseEnter={() => handleMouseEnter(value)}
                    onMouseLeave={handleMouseLeave}
                    disabled={readOnly}
                    aria-label={`${value} star${value > 1 ? 's' : ''}`}
                >
                    ★
                </button>
            ))}
        </div>
    );
};

export default StarRating;
